import {
    Box,
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Text,
    Icon,
    HStack,
    Badge,
    Divider,
    Link,
  } from '@chakra-ui/react';
  import { FaBell, FaExclamationCircle, FaWhatsapp, FaUser } from 'react-icons/fa';
  import { Link as RouterLink } from 'react-router-dom';
  import { useGetAccount } from '@/lib/sdk/accounts/queries';
  import { useGetSettings } from '@/lib/sdk/whatsapp/queries';
  import { useMemo } from 'react';
  
  const NotificationsMenu = () => {
    const { data: account } = useGetAccount();
    const { data: whatsappSettings } = useGetSettings();
  
    const notifications = useMemo(() => {
      const items = [];
  
      // Check business profile completeness
      if (account?.profile) {
        const profile = account.profile;
        const missingFields = [];
  
        if (!profile.org_name) missingFields.push('Organization Name');
        if (!profile.org_registered_name) missingFields.push('Registered Name');
        if (!profile.org_address) missingFields.push('Address');
        if (!profile.city) missingFields.push('City');
        if (!profile.state) missingFields.push('State');
        if (!profile.country) missingFields.push('Country');
        if (!profile.tax_number) missingFields.push('Tax Number');
        if (!profile.hsn_number) missingFields.push('HSN Number');
        if (!profile.pan_number) missingFields.push('PAN Number');
        if (!profile.dig_signature) missingFields.push('Digital Signature');
  
        if (missingFields.length > 0) {
          items.push({
            type: 'profile',
            count: missingFields.length,
            fields: missingFields,
          });
        }
      }
  
      // Check WhatsApp settings
      if (!whatsappSettings || 
            !whatsappSettings.access_token ||
            !whatsappSettings?.whatsapp_number || 
            !whatsappSettings?.payment_link_template || 
            !whatsappSettings?.team_checkin_template ||
            !whatsappSettings?.team_lease_template ||
            !whatsappSettings?.team_lease_offline_template) {
        items.push({
          type: 'whatsapp',
          fields: ['WhatsApp Business API configuration is incomplete'],
        });
      }
  
      return items;
    }, [account, whatsappSettings]);
  
    const totalCount = notifications.reduce((acc, item) => acc + (item.count || 1), 0);
  
    if (totalCount === 0) return null;
  
    return (
      <Menu>
        <MenuButton
          as={IconButton}
          icon={
            <Box position="relative">
              <Icon as={FaBell} color="gray.300" boxSize={5} />
              <Badge
                position="absolute"
                top="-2px"
                right="-2px"
                colorScheme="red"
                borderRadius="full"
                minW="18px"
                h="18px"
                fontSize="xs"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {totalCount}
              </Badge>
            </Box>
          }
          variant="ghost"
          aria-label="Notifications"
          _hover={{ bg: 'whiteAlpha.200' }}
        />
        <MenuList
          bg="gray.800"
          borderColor="whiteAlpha.200"
          boxShadow="lg"
          py={2}
          minW="320px"
        >
          {notifications.map((notification, index) => (
            <Box key={notification.type}>
              {index > 0 && <Divider my={2} borderColor="whiteAlpha.200" />}
              <MenuItem
                as={RouterLink}
                to="/admin/settings"
                py={3}
                _hover={{ bg: 'whiteAlpha.200' }}
              >
                <HStack spacing={3} align="flex-start">
                  <Icon
                    as={notification.type === 'whatsapp' ? FaWhatsapp : FaUser}
                    color={notification.type === 'whatsapp' ? 'green.400' : 'purple.400'}
                    boxSize={5}
                    mt={1}
                  />
                  <Box>
                    <HStack>
                      <Text fontWeight="medium">
                        {notification.type === 'whatsapp'
                          ? 'WhatsApp Configuration Required'
                          : 'Complete Your Business Profile'}
                      </Text>
                      <Icon as={FaExclamationCircle} color="red.400" />
                    </HStack>
                    <Text fontSize="sm" color="gray.400" mt={1}>
                      {notification.fields.join(', ')}
                    </Text>
                    <Link
                      as={Text}
                      fontSize="sm"
                      color="purple.400"
                      mt={2}
                      display="inline-block"
                    >
                      Go to Settings →
                    </Link>
                  </Box>
                </HStack>
              </MenuItem>
            </Box>
          ))}
        </MenuList>
      </Menu>
    );
  };
  
  export default NotificationsMenu;